/*global jQuery, STUDIP */
STUDIP.domReady(() => {
    STUDIP.Blubber.init();
});